import { inject } from '@angular/core';
import { CourseLevelApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const courseLevelTableConfig = (): TableConfig => {
  const courseLevelApiService = inject(CourseLevelApiService);

  return {
    title: 'Quản lý Level',
    entityName: 'level',
    service: courseLevelApiService,
    method: 'getCourseLevels',
    columns: [
      { field: 'code', header: 'Mã level', width: 'min-w-[120px]', sortable: true, type: 'tag', tagColor: 'tagColor', tagTextColor: 'tagTextColor' },
      { field: 'name', header: 'Tên level', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'sortIndex', header: 'Thứ tự', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'tagColor', header: 'Màu tag', width: 'min-w-[100px]', sortable: false, type: 'color' },
      { field: 'tagTextColor', header: 'Màu chữ', width: 'min-w-[100px]', sortable: false, type: 'color' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};
